import "@/App.css";
import { NavBar } from "./components/landing/NavBar";
import { TickerBar } from "./components/landing/TickerBar";
import { HeroSection } from "./components/landing/HeroSection";
import { FeaturesSection } from "./components/landing/FeaturesSection";
import { ArchivedResearchSection } from "./components/landing/ArchivedResearchSection";
import { KiraScoreSection } from "./components/landing/KiraScoreSection";
import { TeamSection } from "./components/landing/TeamSection";
import { TestimonialsSection } from "./components/landing/TestimonialsSection";
import { CtaSection, LegalDisclaimer } from "./components/landing/CtaSection";
import { Footer } from "./components/landing/Footer";
import { useRevealOnScroll, useTickerQuotes } from "./components/landing/hooks";

const goToSignup = () => {
  window.location.href = "/signup.html";
};

const goToLogin = () => {
  window.location.href = "/client-login.html";
};

// V6.0 — If Google Auth redirected here with #session_id=…, forward to client-login.html
// which owns the session exchange. Keeps the landing bundle small and auth logic centralised.
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
if (typeof window !== "undefined" && window.location.hash && window.location.hash.includes("session_id=")) {
  window.location.replace("/client-login.html" + window.location.hash);
}

const scrollToArchived = (e) => {
  if (e) e.preventDefault();
  const el = document.getElementById("archived-research");
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

const Home = () => {
  useRevealOnScroll();
  const ticker = useTickerQuotes();

  return (
    <div className="kira-landing" data-testid="landing-root">
      <div className="bg-grain" aria-hidden="true" />
      <div className="bg-glow" aria-hidden="true" />

      {/* Compliance bar */}
      <div className="disclaimer-bar" data-testid="disclaimer-bar">
        ⚠ Educational use only. KIRA Markets is <strong>not</strong> a SEBI-registered investment adviser. All investments carry market risk.
      </div>

      <NavBar onLogin={goToLogin} onArchivedClick={scrollToArchived} />

      <main data-testid="landing-main">
        <TickerBar ticker={ticker} />
        <HeroSection onLogin={goToSignup} />
        <FeaturesSection />
        <ArchivedResearchSection onLogin={goToSignup} />
        <KiraScoreSection />
        <TeamSection />
        <TestimonialsSection />
        <CtaSection onLogin={goToSignup} />
        <LegalDisclaimer />
      </main>

      <Footer onArchivedClick={scrollToArchived} />
    </div>
  );
};

function App() {
  return <Home />;
}

export default App;
